export default "__VITE_ASSET__8b65e640__"